import ImprintPage from "./ImprintPage";

export default ImprintPage;